import { idtype, inlineImage } from "querypieces";

export default `
... on pageBuilder_inlinePhotoMatrix_BlockType {
	${idtype}
	inlinePhotoMatrix {
	  ... on inlinePhoto_Entry {
		id
		altText
		photoBorderSwitch
		${inlineImage}
	  }
	  ... on bigHeader_Entry {
		id
		header
	  }
	  ... on bodyCopy_Entry {
		id
		body
	  }
	  ... on subheader2_Entry {
		id
		subheader
	  }
	  ... on cta2_Entry {
		id
		cta {
			title
			text
			type 
			url 
			element {
				uri
			}
		}
	  }
	  ... on contactDownloadCta_Entry {
		id
		phoneNumber {
			url
			customText
			text
		}
		email {
			url
			text
			customText
		}
		location
		downloadCta {
			url
			text
			type
		}
	  }
	}
  }
`
